module.exports = __webpack_public_path__ + "static/media/pair-logo-small.0b4fa95a.png";